import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import { Button } from 'reactstrap';
import UserDocuments from '../../../UserProfile/components/UserDocuments';

const ModalDocumentMembership = ({ closeModal, openModal,idUser,idTeamInvestorMember }) => {

    React.useEffect(() => {
      
    }, []);

    return (
        <div>
            <Modal
                open={openModal}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        {idUser != null && idUser != undefined ? 
                        <UserDocuments 
                        id_usuario={parseInt(idUser)} 
                        idTeamInvestorMember={idTeamInvestorMember}
                        permissionUpload={false}
                        /> : null}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
export default ModalDocumentMembership;
